import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { TimeRange } from './time-range.enum'
import { getTimeRangeByEnum } from '@/utils/time'


export default /*#__PURE__*/_defineComponent({
  __name: 'time-range-select',
  props: {
  modelValue: {
    type: String as () => TimeRange | string,
    default: TimeRange.DAYS_30
  },
  width: {
    type: [String, Number],
    default: 120
  },
  showAll: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()

const props = __props

const emits = __emit

const TIME_RANGE_OPTIONS = computed(() => {
  void locale.value
  const options = [
    { label: t('common.timeRangeLast24h'), value: TimeRange.HOURS_24 },
    { label: t('common.timeRangeLast7d'), value: TimeRange.DAYS_7 },
    { label: t('common.timeRangeLast30d'), value: TimeRange.DAYS_30 }
  ]
  if (props.showAll) {
    options.unshift({ label: t('common.timeRangeAll'), value: TimeRange.ALL })
  }
  return options
})

const localValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value)
  }
})

const style = computed(() => ({
  width: typeof props.width === 'number' ? `${props.width}px` : props.width
}))

function handleChange (value: TimeRange) {
  const timeRangeArray = getTimeRangeByEnum(value)
  emits('update:modelValue', value)
  emits('change', value, timeRangeArray)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: localValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
    size: "mini",
    style: _normalizeStyle(style.value),
    disabled: __props.disabled,
    onChange: handleChange
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(TIME_RANGE_OPTIONS.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "style", "disabled"]))
}
}

})